export class MfaRequiredError extends Error {
    userId: number;

    constructor(userId: number, message: string) {
        super(message);
        this.userId = userId;
    }
}
